import { WEB_COMPONENT_MOBILE_SECURITY_CUSTOMER_VIEW } from '../../webcomponents.constants';
import { MobileSecurityCustomerViewWebComponent } from './component/MobileSecurityCustomerViewWebComponent';

export { MobileSecurityCustomerViewWebComponent };

window.customElements.define(WEB_COMPONENT_MOBILE_SECURITY_CUSTOMER_VIEW, MobileSecurityCustomerViewWebComponent);
